

















































































import {
  selectListData,
  studentselectList,
  studentListAdd,
} from "@/api/rollCallDetails";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() student_ids!: any;
  @Prop() classIds!: any;
  @Prop() lesson_id!: any;
  tableData = [];
  page = 1;
  pageSize = 10;
  pageSizeArray = [5, 10, 30, 50, 100];
  total = 5;
  dialogVisible = false;
  suspensionBtn = false;
  student_id = 0;
  class_id = 0;
  student_list = [];
  created() {
    const _t = this as any;
    _t.student_id = _t.student_ids;
    _t.class_id = _t.classIds;
    _t.lesson_ids = _t.lesson_id;
    _t.dialogVisible = true;
    _t.getData({
      page: _t.page,
      page_size: _t.pageSize,
      original_class_id: _t.class_id,
    });
  }
  selectInit(row: any, index: any) {
    if (row.checkbox) {
      return false; //不可勾选
    } else {
      return true; //可勾选
    }
  }
  handleSelectionChange(e: any) {
    const _t = this as any;
    const student = e.map((a: any) => {
      return {
        student_id: a.student_id,
        course_id: a.consume_course_id,
      };
    });
    _t.student_list = student;
  }
  getStudentListAdd() {
    const _t = this as any;
    if (_t.student_list.length == 0) {
      _t.$message({
        type: "error",
        message: "请选择要添加学员",
      });
      return;
    }
    const data = {
      lesson_id: _t.lesson_id,
      student_type: 1,
      in_roll_call: true,
      student_list: _t.student_list,
    };
    studentListAdd(data).then((res: any) => {
      if (res.error_code == 0) {
        _t.$message({
          type: "success",
          message: "添加成功",
        });
        _t.$emit("goBack", res.data.list);
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  resumeclickClose() {
    const _t = this as any;
    _t.dialogVisible = false;
    _t.$emit("goBack");
  }
  handleCourseChange(e: any, item: any) {
    const _t = this as any;
    _t.tableData[_t.tableData.indexOf(item)].course_list.map((a: any) => {
      if (e == a.course_id) {
        _t.tableData[_t.tableData.indexOf(item)].usable_number =
          a.account.usable_number;
      }
    });
  }
  getData(data: selectListData) {
    const _t = this as any;
    data.in_roll_call = true;
    studentselectList(data).then((res: any) => {
      if (res.error_code == 0) {
        if (res.data.list != null) {
          res.data.list.map((a: any) => {
            a.checkbox = false;
            a.consume_course_id = a.course_list[0].course_id;
            a.usable_number = a.course_list[0].account.usable_number;
            if (_t.student_id.length > 0) {
              _t.student_id.map((b: any) => {
                if (a.student_id == b) {
                  a.checkbox = true;
                }
              });
            }
          });
        }
        _t.tableData = res.data.list;
        _t.total = res.data.total;
        _t.page = res.data.page;
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  goBack() {
    this.$router.go(-1);
  }
  handlePagerChange(e: any) {
    const _t = this;
    _t.page = e;
    _t.getData({
      page: e,
      page_size: _t.pageSize,
      original_class_id: _t.class_id,
    });
  }
  handlePagerSizeChange(e: any) {
    const _t = this;
    _t.pageSize = e;
    _t.getData({
      page: _t.page,
      page_size: e,
      original_class_id: _t.class_id,
    });
  }
}
